import { Maybe } from '@App/common/types'
import DocumentUploadForm from '@Components/DocumentUploadForm'
import React, { useContext } from 'react'
import { PARAM } from '@App/navigation/param'
import { useParams } from 'react-router'
import { StoresContext } from '@App/contexts'
import { generateOverclaimDocumentUploadUrl } from '@App/api/routes/overclaim'
import OverclaimDocumentationWarning from '@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView/OverclaimDocumentUploadForm/OverclaimDocumentationWarning'

export const UPLOAD_DOCUMENTS_FORM_ACCEPTED_FILE_TYPES = [
    '.docx',
    '.doc',
    '.csv',
    '.xls',
    '.xlsx',
    '.pdf',
    '.png',
    '.jpeg',
    '.jpg',
]
export const UPLOAD_DOCUMENTS_FORM_MAX_FILE_SIZE_IN_BYTES = 50 * 1024 * 1024

export const UPLOAD_OC_DOC_DESCRIPTION_HELP_TEXT = 'Please add which share this is for and any other information'

interface OverclaimDocumentUploadFormProps {
    onDoneClicked: () => void
}

const OverclaimDocumentUploadForm = ({ onDoneClicked }: OverclaimDocumentUploadFormProps) => {
    const { rightsholderStore } = useContext(StoresContext)
    const params = useParams<typeof PARAM>()
    const overclaimHeaderId = params.overclaimHeaderId && +params.overclaimHeaderId

    const generateS3PresignedUrl = async (
        fileName: string,
        fileSize: number,
        fileDescription: Maybe<string>,
        fileHash?: Maybe<string>
    ) => {
        if (overclaimHeaderId) {
            const response = await generateOverclaimDocumentUploadUrl(
                rightsholderStore.currentRightsholderId,
                overclaimHeaderId,
                fileName,
                fileSize,
                fileDescription,
                fileHash
            )
            return response.data
        } else {
            throw new Error('Overclaim header ID is not defined')
        }
    }

    return (
        <DocumentUploadForm
            title={<h3>Upload Documentation</h3>}
            onDoneClicked={onDoneClicked}
            allowedFilesConfig={{
                allowedFileTypes: UPLOAD_DOCUMENTS_FORM_ACCEPTED_FILE_TYPES,
                maximumFileSizeInBytes: UPLOAD_DOCUMENTS_FORM_MAX_FILE_SIZE_IN_BYTES,
            }}
            displayConfig={{ descriptionHelpText: UPLOAD_OC_DOC_DESCRIPTION_HELP_TEXT }}
            generateS3PresignedUrl={generateS3PresignedUrl}
            hashFiles
            confirmationPopupConfig={{
                confirmationPopupTitle: 'Upload Documentation',
                confirmationPopupBody: <OverclaimDocumentationWarning />,
            }}
        />
    )
}

export default OverclaimDocumentUploadForm
